var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactTitleAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 64,
    viewBox: "0 0 220 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.121 51.0329C124.414 44.0573 119.013 38.1802 112.056 37.8689C105.08 37.576 99.2031 42.977 98.8919 49.9343C98.5989 56.9099 104 62.787 110.957 63.0982C117.933 63.3912 123.81 57.9901 124.121 51.0329ZM170.954 40.4137C171.339 31.3143 164.29 23.6247 155.191 23.2219C146.091 22.8374 138.402 29.8862 137.999 38.9856C137.614 48.085 144.663 55.7746 153.763 56.1774C162.862 56.5619 170.552 49.5131 170.954 40.4137ZM72.9301 27.085C79.8874 27.3962 85.2885 33.2733 84.9955 40.2489C84.6843 47.2062 78.8072 52.6072 71.8316 52.3143C64.8744 52.003 59.4733 46.126 59.7662 39.1504C60.0775 32.1931 65.9546 26.792 72.9301 27.085ZM45.7418 27.4696C45.9431 22.5629 42.1349 18.4068 37.2282 18.1871C32.3215 17.9857 28.1655 21.7939 27.9458 26.7007C27.7444 31.6074 31.5526 35.7634 36.4593 35.9831C41.366 36.1845 45.522 32.3763 45.7418 27.4696ZM204.203 0.0251198C213.302 0.409603 220.37 8.11755 219.985 17.2169C219.582 26.3163 211.893 33.3652 202.793 32.9807C193.694 32.5779 186.645 24.8883 187.029 15.7889C187.432 6.68947 195.122 -0.35936 204.221 0.0251198H204.203ZM13.4087 7.00069C13.5734 3.30235 10.699 0.17157 7.00064 0.00679398C3.30229 -0.157986 0.171509 2.71647 0.00672913 6.41482C-0.158035 10.1132 2.71642 13.2439 6.41476 13.4087C10.1131 13.5735 13.2439 10.699 13.4087 7.00069Z",
    fill: "#BBCAD2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTitleAfter);
export default __webpack_public_path__ + "static/media/contactTitleAfter.f1d7d910ad63e89d718786373a7c67b2.svg";
export { ForwardRef as ReactComponent };